import { render, staticRenderFns } from "./OutboundPopup.vue?vue&type=template&id=588c2435&scoped=true&"
import script from "./OutboundPopup.vue?vue&type=script&lang=js&"
export * from "./OutboundPopup.vue?vue&type=script&lang=js&"
import style0 from "./OutboundPopup.vue?vue&type=style&index=0&id=588c2435&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588c2435",
  null
  
)

export default component.exports